import classnames from 'classnames';
import React from 'react';

import { formatKpi, Kpi } from '@utils/Formatters';

import * as styles from './PosFact.module.scss';
import { GrowthTypes } from '../comparison-growth-selector/Types';

/* eslint-disable-next-line */
export interface PosFactProps {
  type: Kpi;
  growthType: string;
  value?: number;
  subValue?: number;
  growthTypeText: string;
  growthAvailable: boolean;
  percentage?: number | null;
  actual?: number | null;
  currency?: string;
}

export enum ValueType {
  ABSOLUTE,
  PERCENTAGE_CHANGE,
  ABSOLUTE_CHANGE,
}

const verifyDisplayValue = (growthType: string, actual: number | null, percentage: number | null) => {
  return growthType === GrowthTypes.actual ? actual : percentage;
};

const PosFact: React.FC<PosFactProps> = ({
  type,
  value = undefined,
  subValue = undefined,
  growthType,
  percentage = 0,
  growthTypeText,
  actual = 0,
  currency,
  growthAvailable,
}) => {
  const displayValue = growthAvailable ? verifyDisplayValue(growthType, actual, percentage) : undefined;
  const isPositiveGrowth = growthAvailable && Math.sign(displayValue ?? 0) === 1;
  const isNegativeGrowth = growthAvailable && Math.sign(displayValue ?? 0) === -1;
  const isZeroGrowth = !growthAvailable || Math.sign(displayValue ?? 0) === 0;

  return (
    <div className={styles.PosFact__CardItem}>
      <div data-test-id={'pf-card'}>
        <p className="text-lighter text-md mb-2 white-space-nowrap" data-test-id="pf-type">
          {growthTypeText}
        </p>
        <p className="text-default text-4xl mb-1" data-test-id="pf-value">
          {value !== undefined && value !== null ? formatKpi(type, value, { currencySymbol: currency }) : ''}
        </p>
        <p className="text-default text-xl mb-1">
          {subValue !== undefined && subValue !== null
            ? formatKpi(type, subValue, { as: ValueType.PERCENTAGE_CHANGE })
            : ''}
        </p>
        <p className="text-lg font-bold mb-4">
          <span
            data-test-id="pf-kpi"
            className={classnames([
              styles.PosFact__KpiGrowthValue,
              {
                'text-ui-green': isPositiveGrowth,
              },
              {
                'text-ui-red': isNegativeGrowth,
              },
              {
                'text-ui-green': isZeroGrowth,
              },
            ])}
          >
            {growthType === GrowthTypes.actual
              ? formatKpi(type, displayValue, {
                  currencySymbol: currency,
                  as: ValueType.ABSOLUTE_CHANGE,
                })
              : formatKpi(type, displayValue, { as: ValueType.PERCENTAGE_CHANGE })}
          </span>
        </p>
      </div>
    </div>
  );
};

export default PosFact;
